import React from 'react';
import { Saturation } from 'react-color/lib/components/common';

class GreenShadePicker extends React.Component {
    state = {
        hsl: { h: 120, s: 50, l: 50, a: 1 }, // Locked to green hue
    };

    handleSaturationChange = (color) => {
        this.setState({ hsl: color.hsl });
    };

    render() {
        const { hsl } = this.state;

        return (
            <div className='relative w-32 h-32'>
                <Saturation
                    hsl={hsl}
                    hsv={hsl}
                    onChange={this.handleSaturationChange}
                />
            </div>
        );
    }
}

export default GreenShadePicker;
